<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <!-- Close Button (Modal or Selection) -->
        <div class="icon-btn" (click)="close()" *ngIf="viewMode === 'modal' || selectionMode">
          <ion-icon name="close-outline"></ion-icon>
        </div>
        
        <!-- Menu Button (Page Mode) -->
        <div class="icon-btn" *ngIf="viewMode === 'page' && !selectionMode">
          <ion-buttons slot="start">
            <ion-menu-button style="--color: white;"></ion-menu-button>
          </ion-buttons>
        </div>

        <div class="title-group">
          <div class="title-main" (click)="loadCotizaciones()" 
            style="display: flex; align-items: center; gap: 8px; width: fit-content; cursor: pointer;">
            {{ selectionMode ? 'Vincular Cotización' : 'Cotizaciones' }}
            <ion-icon name="refresh-outline" style="font-size: 1.1rem; opacity: 0.8;"></ion-icon>
          </div>
          <div class="title-sub" *ngIf="trabajo">{{ trabajo.lugar }}</div>
          <div class="title-sub" *ngIf="!trabajo">Gestión de presupuestos</div>
        </div>

        <div class="header-actions">
          <div class="icon-btn" (click)="openFilter()">
            <ion-icon name="options-outline"></ion-icon>
            <span class="filter-badge" *ngIf="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="premium-content-bg" [fullscreen]="true" [scrollY]="false">
    <div class="page-layout">
      
      <!-- Fixed Search Bar -->
      <div class="search-wrapper">
        <ion-searchbar 
          class="premium-searchbar" 
          placeholder="Buscar cotización..." 
          [(ngModel)]="searchText"
          (ionInput)="search($event)" 
          [debounce]="300">
        </ion-searchbar>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <ion-spinner name="bubbles"></ion-spinner>
        <p>Cargando cotizaciones...</p>
      </div>

      <!-- Scrollable List Area -->
      <div class="list-scroll-area" (scroll)="onListScroll($event)">
        <div class="list-container premium-list-container">
          
          <!-- Empty State -->
          <div *ngIf="!isLoading && displayedCotizaciones.length === 0" class="empty-state">
            <ion-icon name="document-text-outline"></ion-icon>
            <p>{{ selectionMode ? 'No hay cotizaciones disponibles' : 'No se encontraron cotizaciones' }}</p>
            <ion-button fill="clear" (click)="loadCotizaciones()" *ngIf="searchText">Ver todas</ion-button>
          </div>

          <!-- Cotización Cards -->
          <div class="cotizacion-card" *ngFor="let c of displayedCotizaciones; trackBy: trackByFn" 
            [class.active-card]="activeCotizacionId === c.id"
            (click)="openMenu(c)">

            <div class="card-indicator"></div>
            
            <div class="card-main-col">
              <div class="card-content-upper">
                <div class="card-body">
                  <div class="card-header-row">
                    <span class="card-id">#{{ c.id }}</span>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div class="estado-badge" [ngClass]="getEstadoClass(c.estado)"
                        (click)="changeStatus(c); $event.stopPropagation()">
                        {{ c.estado }}
                        <ion-icon name="caret-down-outline" style="font-size: 10px; margin-left: 2px;" *ngIf="!selectionMode"></ion-icon>
                      </div>
                    </div>
                  </div>

                  <div class="card-main-info">
                    <div class="titulo">{{ c.cliente }}</div>
                    
                    <div class="info-container">
                      <div class="info-row" *ngIf="c.direccion">
                        <ion-icon name="location-outline" class="info-icon location"></ion-icon>
                        <span class="info-text">{{ c.direccion }}</span>
                      </div>
                      <div class="info-row" *ngIf="c.solicitante">
                        <ion-icon name="person-outline" class="info-icon solicitor"></ion-icon>
                        <span class="info-text small">Solicitante: {{ c.solicitante }}</span>
                      </div>
                    </div>

                    <div class="descripcion" *ngIf="c.descripcion">{{ c.descripcion }}</div>
                    <div class="fecha">{{ c.fecha | date:'dd MMM, yyyy' }}</div>

                    <!-- Mini badges de estado de envío (Solo para Aprobadas) -->
                    <div class="envios-status-row" *ngIf="(c.estado || '').toLowerCase() === 'aprobada'">
                      <span class="status-indicator" [class.correo-sent]="c.correoEnviadoFecha"
                        (click)="registrarEnvioDirecto(c, 'Correo enviado'); $event.stopPropagation()">
                        <ion-icon [name]="c.correoEnviadoFecha ? 'mail-open-outline' : 'mail-outline'"></ion-icon>
                        {{ c.correoEnviadoFecha ? 'Cotización Enviada (' + (c.correoEnviadoFecha | date:'dd MMM') + ')' : 'Falta Enviar Cotización' }}
                      </span>
                      <span class="status-indicator" [class.ars-sent]="c.arsEnviadoFecha"
                        *ngIf="(c.cliente || '').toLowerCase().includes('don antonio')"
                        (click)="registrarEnvioDirecto(c, 'ARS enviado'); $event.stopPropagation()">
                        <ion-icon [name]="c.arsEnviadoFecha ? 'document-text-outline' : 'document-outline'"></ion-icon>
                        {{ c.arsEnviadoFecha ? 'ARS Enviado (' + (c.arsEnviadoFecha | date:'dd MMM') + ')' : 'Falta Enviar ARS' }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="card-arrow">
                  <ion-icon [name]="selectionMode ? 'link-outline' : 'chevron-forward-outline'"></ion-icon>
                </div>
              </div>

              <!-- Footer: OCs and Invoices -->
              <div class="oc-footer-row" *ngIf="c.hasOc > 0 || (c.facturas && c.facturas.length > 0) || c.facturaFiscal">
                <!-- OC Badges -->
                <ng-container *ngIf="c.ocList && c.ocList.length > 0">
                  <div class="oc-badge" *ngFor="let oc of c.ocList">
                    <ion-icon name="document-attach-outline"></ion-icon>
                    <span>{{ oc.split(' (')[0] }}</span>
                  </div>
                </ng-container>

                <!-- Invoice Badges -->
                <div class="factura-badge" *ngFor="let fact of c.facturas" [class.pagada]="fact.pagado"
                  (click)="viewInvoicePdf(fact.id); $event.stopPropagation()">
                  <ion-icon [name]="fact.pagado ? 'checkmark-circle' : 'receipt-outline'"></ion-icon>
                  <span>FACT #{{ fact.id }}</span>
                  <ion-icon name="eye-outline" class="view-icon"></ion-icon>
                </div>

                <!-- Fiscal Invoice -->
                <div class="factura-badge pagada" *ngIf="c.facturaFiscal" 
                  (click)="viewInvoicePdf(c.facturaFiscal.id); $event.stopPropagation()">
                  <ion-icon name="ribbon-outline"></ion-icon>
                  <span>FISCAL #{{ c.facturaFiscal.id }}</span>
                  <ion-icon name="eye-outline" class="view-icon"></ion-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <!-- FAB -->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="!selectionMode">
    <ion-fab-button (click)="addCotizacion()" class="fab-btn premium-fab">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-footer class="ion-no-border premium-list-footer"></ion-footer>
</div>